export default "__VITE_ASSET__WEzzOT3F__";